export const m0l1Solution = `// TODO: This lesson won't compile... Can you make it compile?
fn main() {}

// do not modify code on this line or below

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
